import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslationService } from '@tt-lib/services/translation.service';
import { MatAnchor, MatButtonModule } from "@angular/material/button";
import {MatDialogModule} from '@angular/material/dialog';

@Component({
  selector: 'tt-newversion-dialog',
  imports: [TranslateModule, MatAnchor, MatButtonModule, MatDialogModule],
  templateUrl: './newversion-dialog.component.html',
  styleUrl: './newversion-dialog.component.scss'
})
export class NewversionDialogComponent {
}